export const downloadBlob = (blob: BlobPart, name: string) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
